module.exports = __webpack_public_path__ + "images/chats-selectedac2c56e98dcfe82806b5d2e8c43bd79f.png";